import { FC, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoader } from 'thermia-react-container';
import { yupInitialize } from '../translations/yup/yup';
import { RegistrationsContext } from './contextProvider';
import { useAppState } from './contextState';
import OnBehalfOfNotice from "../components/onBehalfOfNotice";
export const RegistrationsProvider: FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const contextState = useAppState();
  const { config } = contextState;
  const { installationConfig, isLoading, fetchInstallationConfig } = config;
  const { Loader, showLoader, hideLoader } = useLoader();
  const { t } = useTranslation('registrations');

  useEffect(() => {
    if (!installationConfig) {
      showLoader();
      fetchInstallationConfig();
      hideLoader();
    }
  }, [contextState, fetchInstallationConfig, hideLoader, installationConfig, showLoader]);

  useEffect(() => {
    yupInitialize(t);
  }, [t]);

  return (
    <>
      {!installationConfig || isLoading ? <Loader /> : <RegistrationsContext.Provider value={contextState}>
        <OnBehalfOfNotice/>
        {children}
      </RegistrationsContext.Provider>}
    </>
  );
};
